/**
 * Auth Layout Component
 *
 * Centered card layout for authentication pages.
 * Per UX specification:
 * - Centered card layout
 * - Max-width: 400px
 * - Background: shared --app-surface token (translucent light blue), matching the app shell / editor canvas
 * - Card with subtle shadow
 */

import type { ReactNode } from "react";
import { Link } from "@tanstack/react-router";
import { Logo } from "../icons/Logo";

interface AuthLayoutProps {
  children: ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 shadow-lg" style={{ backgroundColor: "var(--app-surface)" }}>
      {/* Brand header */}
      <div className="mb-1 flex justify-center">
        <Logo height={78} />
      </div>

      {/* Auth content */}
      <div className="w-full max-w-[400px]">
        {children}
      </div>

      {/* Footer */}
      <footer className="mt-8 text-center text-xs text-muted-foreground">
        <p>
          By continuing, you agree to our{" "}
          <Link to="/terms" className="underline hover:text-foreground">
            Terms of Service
          </Link>{" "}
          and{" "}
          <Link to="/privacy" className="underline hover:text-foreground">
            Privacy Policy
          </Link>
        </p>
      </footer>
    </div>
  );
}
